const DEMO = {
  BLANK_LINK: "#!",
  MAESTRO_V1_LANDING_PAGE: "/landing",
  MAESTRO_WELCOME_PAGE: "/ie/ieplatform",
  ROCK_APP_URI: "/ie/applications/rock",
  SHIPMENT_QNA_URI: "/ie/applications/shipmentqna",
  TRITON_URI: "/ie/applications/triton",
  MAESTRO_COMMON_APP_URI: "/ie/applications/",
  MAESTRO_CATALOGUE: "/ie/applications/catalogue",
  MAESTRO_APPROVAL_REQ: "/ie/applications/approvalrequests",
  MAESTRO_LOG_ANALYTICS: "/ie/applications/loganalytics", //
  ENTERPRISE_DATA_QUALITY: "/ie/applications/enterprisedataquality/",
  INSIGHTS: "/ie/applications/insights/",
  COST_OVERVIEW: "/ie/applications/CostOverview/",
  COST_MGMT: "/ie/applications/MaestroCostmanagement/",
  POWERBIVSAPPS: "/ie/applications/PowerBIPowerApps/",
  CUST_JOURNEY: "/ie/applications/customerjourney",
  DATA_INGSTN_QUALITY: "/ie/applications/maestrodataingestionquality",
  MAESTRO_V2_LANDING_PAGE: "https://maestroplatform.azurewebsites.net",
  MAESTRO_ADMIN: "maestro-Admin",
  MAESTRO_APPROVER: "maestro-Approver",
  MAESTRO_REQUESTER: "maestro-Requestor",
  MAESTRO_READER: "maestro-Reader",
  MASTRO_READER_WRITER: "maestro-Reader-Writer",
  ADMIN_TAB: "admintab",
  LUIS_SUBSCRIPTION_KEY: "Ocp-Apim-Subscription-Key",
  QUEUED: "Queued",
  IN_PROGRESS: "InProgress",
  TRAIN: "train",
  SLASH_PUBLISH: "/publish",
  SUCCESS: "Success",
  UP_TO_DATE: "UpToDate",
  PUBLISH_IN_PROGRESS: "PublishingInProgress",
  FAIL: "Fail",
  INTENTS: "intents",
  EXAMPLE: "example",
  PUBLISHED: "Published",
  ENTITIES: "entities",
  ONTOLOGY_PIPELINE: "IE PLATFORM SQL PIPELINE PILOT",
  //adls governance roles
  MAESTRO_ADLS_ADMIN: "maestro-adls-gov-admin",
  MAESTRO_ADLS_USER: "maestro-adls-gov-user",
  MAESTRO_RATOOL: "maestro-ratool",
  MAESTRO_RATOOL_ADMIN: "maestro-ratool-admin",
  MAESTRO_RATOOL_WRITE: "maestro-ratool-write",
  MAESTRO_GEO_FENCING: "maestro-geofencing",
  MAESTRO_GEOFENCING_ADMIN: "maestro-geofencing-admin",
  //penny pressure roles
  MAESTRO_PENNY_READER: "maestro-penny-read",
  MAESTRO_PENNY_ADMIN: "maestro-penny-admin",

  //apa mirror roles
  MAESTRO_MIRROR_READER_HYOSUNG: "maestro-mirror-hyosung-read",
  MAESTRO_MIRROR_READER_KUMHO: "maestro-mirror-kumho-read",

  //IntermodalRoles
  MEASTRO_INTERMODAL_READER: "maestro-intermod-user",
  MAESTRO_INTERMODAL_ADMIN: "maestro-intermod-admin",

  //MetadataExplorer roles
  MAESTRO_METADATAEXPLORER_ADMIN: "maestro-mme-admin",

  //Masterdata quality roles

  MAESTRO_MASTERDATAQUALITY_READER: "maestro-dataquality-readuser",

  //Github Constants
  MAESTRO_ONTOLOGY_PREFIX: "maestro_ontology_",
  MAESTRO_NON_ONTOLOGY_PREFIX: "maestro_",
  REPO_SUFFIX: "_gen2",
  EXISTING_ONTOLOGY_PREFIX1:
    "ADO_transport-logistics_IE-Maestro-Platform-Migration_",
  EXISTING_ONTOLOGY_PREFIX2: "ADO_transport-logistics_Maestro-Ontology_",
};

export default DEMO;
